export const promoLandingsTranslationKeys = {
  promoLandingsAcceptRules: 'offers.page-offer-tab-activation-accordion-accept-rules-title',
  promoLandingsActivateOffer: 'promo.modal-button-activate-offer',
  promoLandingsAfftrack: 'statistics.afftrack-label',
  promoLandingsCopiedLink: 'promo.copied-link',
  promoLandingsCopyLink: 'promo.copy-link',
  promoLandingsGeneratedLink: 'promo.generated-link',
  promoLandingsGenerateLink: 'promo.generate-link',
  promoLandingsModel: 'settings.affiliate-model',
  promoLandingsPreview: 'promo.preview',
  promoTypeHere: 'promo.type-here',
}
